<template>
    <div
        v-if="websites"
        class="widget active-sites-widget"
    >
        <header class="widget-header">
            <h3><i class="fal fa-browser" /> Active Sites</h3>
        </header>
        <div class="widget-body">
            <ul class="websites">
                <li v-for="website in websites" :key="website.id">
                    {{ website.home }}
                </li>
            </ul>
            <router-link to="/settings/sites">
                Manage Sites →
            </router-link>
</div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    computed: mapGetters(['websites']),
};
</script>
